module.exports = __webpack_public_path__ + "img/ic_preview.856ae4bc.svg";